import API from "../BaseURL";

const config = {
  headers: {
    "content-type": "application/x-www-form-urlencoded",
  },
};

export async function token(data) {
  const res = API.post(
    `/token`,
    data,
    config
  );
  return res;
}
